<template>
	<el-row class="home">
		<el-col>
			<div class="home_top_message" :span="24" justify="center">
				欢迎使用后台管理系统（V1.2）,您本次登录为{{time}}
			</div>
		</el-col>
		<el-col>
			<div class="home_data">
				<div :class="{box_margin:index!==3,data_item:true}" v-for="(item,index) in shopData" :key="index">
					<div class="title">{{title[index]}}</div>
					<div class="detail">
						<div class="money">{{index>1?`${item.money}`:`￥${item.money}`}}</div>
						<div class="trend" v-if="item.up&&item.down">
							<div class="top"><i class="el-icon-top" style="color:#02D180">20%</i>同比昨日</div>
							<div class="bottom"><i class="el-icon-bottom" style="color:#FF5860">20%</i>同比昨日</div>
						</div>
						<template v-else>
							<div class="text-12" v-if="item.up">
								<i class="el-icon-top" style="color:#02D180">{{item.up}}</i>同比昨日
							</div>
							<div class="text-12" v-if="item.down">
								<i class="el-icon-top" style="color:#02D180">{{item.down}}</i>同比昨日
							</div>
						</template>
					</div>
				</div>
			</div>
		</el-col>
		<el-col>
			<div class="home_detail">
				<div class="chart">
					<el-row>
						<el-col :span="7">
							<div class="text-12">选择年度</div>
							<el-select size="mini" v-model="value" placeholder="请选择" style="width:60%;margin-left:15px">
								<el-option v-for="item in options" :key="item.value" :label="item.label"
									:value="item.value">
								</el-option>
							</el-select>
							<el-button size="mini" style="margin-left:10px">统计</el-button>
						</el-col>
						<el-col :span="4" :offset="3">
							<div class="text-12">人员</div>
							<el-input size="mini" v-model="input" placeholder="请输入内容"
								style="width:75%;margin-left:15px"></el-input>
						</el-col>
						<el-col :span="2" :offset="8">
							<el-button size="mini">返回上一级</el-button>
						</el-col>
					</el-row>
					<el-divider></el-divider>
					<div id="myChart" :style="{width: '100%', height: '330px'}"></div>
				</div>
			</div>
		</el-col>
		<!-- 底部 -->
		<el-col>
			<div class="home_bottom_data">
				<div style="padding:20px" :class="{box_margin:index!==3,bottom_data:true}"
					v-for="(item,index) in mokeData" :key="index">
					<el-card class="box-card" shadow="never" :body-style="{width:'100%',height:'100%'}">
						<div slot="header" class="clearfix">
							<span>{{item.title}}</span>
						</div>
						<el-row v-for="(o,i) in item.dataList" :key="i" type="flex" class="row-bg"
							justify="space-between">
							<el-col :span="16" class="text-12">{{o.name}}</el-col>
							<el-col v-if="index!==3" :span="3" class="text-12">
								<div style="color:#0062FF;margin-right:4px">{{o.value}}</div>{{index==2?'次':'个'}}
							</el-col>
						</el-row>
					</el-card>
				</div>
			</div>
		</el-col>
	</el-row>
</template>
<script>
	import echarts from 'echarts'
	export default {
		name: 'home',
		data() {
			return {
				options: [{
					value: 1,
					label: 2020
				}, {
					value: 2,
					label: 2019
				}, {
					value: 3,
					label: 2018
				}],
				value: '',
				input: '',
				time: '',
				dataY: [
					223, 452, 267, 289, 423, 222, 126, 322, 234, 123, 110, 93
				],
				dataX: ["一月", "二月", "三月", "四月", "五月", "六月", "七月", "八月", "九月", "十月", "十一月", "十二月"],
				title: ['交易金额', '商城用户', '商城订单', '分期记录'],
				bottomTitle: ['订单统计信息', '商品统计信息', '商品统计信息', '最新消息'],
				shopData: [{
						money: "00,000",
						up: "0%",
						down: null
					},
					{
						money: "00,000",
						up: "0%",
						down: "0%"
					},
					{
						money: "000",
						up: "0%",
						down: null
					},
					{
						money: "000",
						up: "0%",
						down: null
					}
				],
				mokeData: [{
						title: '订单统计信息',
						dataList: [{
								name: '未处理订单',
								value: 0
							},
							{
								name: '待发货订单',
								value: 0
							},
							{
								name: '待结算订单',
								value: 0
							},
							{
								name: '已成交订单数',
								value: 0
							},
							{
								name: '交易失败',
								value: 0
							}
						]
					},
					{
						title: '商品统计信息',
						dataList: [{
								name: '商品总数',
								value: 0
							},
							{
								name: '上架商品',
								value: 0
							},
							{
								name: '下架商品',
								value: 0
							},
							{
								name: '商品评论',
								value: 0
							}
						]
					},
					{
						title: '商品统计信息',
						dataList: [{
								name: '会员登录',
								value: 0
							},
							{
								name: '微信授权登录',
								value: 0
							},
							{
								name: '手机号授权登录',
								value: 0
							}
						]
					},
					{
						title: '最新消息',
						dataList: [{
								name: 'A后台系统找...开通了。'
							},
							{
								name: 'A后台系统找...开通了。'
							},
							{
								name: '3月共处理订单3451比，作废为128...'
							}
						]
					}
				]
			}
		},
		mounted() {
			this.initData()
		},
		methods: {

			initData() {
				let that = this;
				// var option1 = {
				//   title:{
				//      text:'2020年月度销量统计',
				//      left:90
				//   },
				//   xAxis: {
				//     name: "时",
				//     boundaryGap: false,
				//     axisLine: {
				//       lineStyle: {
				//         color: "#d8d8d8" // x坐标轴的轴线颜色
				//       }
				//     },
				//     axisLabel: {
				//       show: true, //这行代码控制着坐标轴x轴的文字是否显示
				//       textStyle: {
				//         color: "#707070", //x轴上的字体颜色
				//         fontSize: "12" // x轴字体大小
				//       }
				//     },
				//     type: "category",
				//     data: this.dataX
				//   },
				//   yAxis: {
				//     name: "销量",
				//     type: "value",
				//     nameTextStyle: {
				//       fontSize: 16
				//     },
				//     splitLine: {
				//       //  改变轴线颜色
				//       lineStyle: {
				//         // 使用深浅的间隔色
				//         color: ""
				//       }
				//     },
				//     axisLine: {
				//       show:false,
				//       lineStyle: {
				//         color: "#d8d8d8" // x坐标轴的轴线颜色
				//       }
				//     },
				//     axisTick: { show: false },
				//     axisLabel: {
				//       textStyle: {
				//         align: "left",
				//         color: "#707070", //x轴上的字体颜色
				//         fontSize: "12" // x轴字体大小
				//       },
				//       formatter: "{value}单",
				//       interval: 98,
				//       margin: 80
				//     },
				//     scale:true,
				//     min: 0,
				//     max: 490,
				//    //  splitNumber:5,
				//     interval:98
				//   },
				//   series: [
				//     {
				//       data:this.dataY,
				//       type: "line",
				//       smooth: true,
				//       // symbol:'circle',
				//       symbolSize:10,
				//       itemStyle: {
				//         normal: {
				//           color: "#5a60c7",
				//           lineStyle: {
				//             color: "#5a60c7"
				//           }
				//         }
				//       },
				//       areaStyle: {
				//           color: new echarts.graphic.LinearGradient(0, 0, 0, 0.8, [{
				//               offset: 0,
				//               color: '#0062FF'
				//           }, {
				//               offset: 0.7,
				//               color: '#ffe'
				//           }])
				//       },
				//       label: {
				//           normal: {
				//               show: true,
				//               position: 'top'
				//           }
				//       },
				//     }
				//   ]
				// };

				let option1 = {
					grid: {
						x: '3%', //左上角x轴距盒子边框的距离
						y: 60, //左上角Y轴距盒子边框的距离
						x2: '3%', //右下角x轴距盒子边框的距离
						y2: 60, //右下角Y轴距盒子边框的距离
						borderWidth: 1
					},
					title: {
						text: '2020年月度销量统计'
					},
					tooltip: {

						trigger: 'axis',
						axisPointer: {
							type: 'cross',
							label: {
								backgroundColor: '#6a7985'
							}
						}
					},
					legend: {
						data: ['销量']
					},
					toolbox: {
						feature: {
							saveAsImage: {}
						}
					},
					xAxis: {
						type: 'category',
						boundaryGap: false,
						data: ['一月', '二月', '三月', '四月', '五月', '六月', '七月', '八月', '九月', '十月', '十一月', '十二月'],
						splitLine: {
							show: false
						},
						axisLine: { //X轴
							"show": false

						},
						axisTick: { //X轴刻度线
							"show": false
						},
						axisLabel: {
							show: true,
							textStyle: {
								color: '#9E9E9E'
							}
						}
					},
					yAxis: [{
						name: '销量',
						type: 'value',
						axisLine: { //y轴
							"show": false

						},
						axisTick: { //y轴刻度线
							"show": false
						},
						splitLine: {
							show: true,
							lineStyle: {
								type: 'dashed'
							}
						},
						axisLabel: {
							show: true,
							textStyle: {
								color: '#9E9E9E'
							},
							// 这里重新定义就可以
							formatter: function(value) {
								var texts = []
								texts.push(value + '单')
								return texts
							}
						}
					}],
					series: [{
						name: '销量',
						data: [98, 932, 901, 934, 1290, 1330, 1320, 98, 932, 901, 934, 1290],
						type: 'line',
						smooth: true,
						areaStyle: {
							color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
								offset: 0,
								color: '#0062FF'
							}, {
								offset: 1,
								color: '#FFFFFF'
							}]),
						},
						itemStyle: {
							normal: {
								color: '#0062FF', //改变折线点的颜色
								lineStyle: {
									color: '#0062FF' //改变折线颜色
								},
								label: {
									show: true
								}
							}
						}
					}]
				};
				that.chart1 = that.$echarts.init(document.getElementById("myChart")); //定义
				that.chart1.clear();
				that.chart1.setOption(option1); //展示
				that.chart1.resize(); //刷新画布
				window.onresize = that.chart1.resize
			}
		},
		created() {
			// this.$notify()
			this.time = this.$moment().format('LLLL')
		},
	};
</script>
<style lang='less' scoped>
	.home {
		.home_top_message {
			width: 100%;
			height: 35px;
			line-height: 35px;
			margin-bottom: 10px;
			color: #0062FF;
			text-align: center;
			font-size: 16px;
			background-color: rgba(0, 98, 255, 0.07);
		}

		.home_data {
			width: 100%;
			display: flex;
			margin-bottom: 10px;

			.data_item {
				flex: 1;
				width: 100%;
				height: 70px;
				padding: 20px;

				.title {
					font-size: 14px
				}

				.detail {
					display: flex;
					align-items: center;
					margin-top: 20px;

					.money {
						font-size: 30px;
						margin-right: 20px;
					}

					.trend {
						font-size: 14px;

						.top {
							margin-bottom: 6px;
						}
					}
				}
			}
		}

		.home_detail {
			width: 100%;
			display: flex;
			margin-bottom: 10px;

			.chart {
				width: 100%;
				height: 430px;
				box-sizing: border-box;
				padding: 15px 30px;

				/deep/.el-divider--horizontal {
					margin: 10px 0;
				}
			}
		}

		.home_bottom_data {
			width: 100%;
			display: flex;

			.bottom_data {
				flex: 1;
				width: 100%;
				height: 265px;

				/deep/.el-card {
					border: 0;
					width: 100%;
					height: 100%;

					/deep/.el-card__header {
						padding: 18px 0
					}

					/deep/.el-card__body {
						padding: 20px 0;

						/deep/.el-row {
							padding: 8px 0;
							color: #AEAEAE;

							/deep/.el-col:nth-child(2) {
								justify-content: flex-end;
							}
						}
					}
				}
			}
		}
	}

	.box_margin {
		margin-right: 30px
	}

	.nav_box,
	.chart,
	.data_item,
	.bottom_data {
		box-shadow: 0px 3px 15px 0px rgba(174, 174, 174, 0.2);
		border-radius: 10px
	}

	.text-12 {
		font-size: 12px;
	}
</style>
